import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import logo from '../../assets/img/AgriX_LogoX.png';
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import AccountCircle from "@material-ui/icons/AccountCircle";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import IconLibraryBooks from '@material-ui/icons/LibraryBooks'
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import IconExpandLess from '@material-ui/icons/ExpandLess';
import IconExpandMore from '@material-ui/icons/ExpandMore';
import GroupIcon from '@material-ui/icons/Group';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import Icon from '@material-ui/core/Icon';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Tooltip from '@material-ui/core/Tooltip';

//import { CommonGet, CommonPost } from "../../utils/CommonFetch";
import Popover from '@material-ui/core/Popover';
import tokenService from '../Common/tokenDecoder';
import { Switch, Redirect, Route } from 'react-router-dom';

import { GroupRoutes } from '../Modules/Group/routes';
import { FactoryRoutes } from '../Modules/Factory/routes';
import { RouteRoutes } from '../Modules/Route/routes';
import { EstateRoutes } from '../Modules/Estate/routes';
import { DivisionRoutes } from '../Modules/Devision/routes';
import { FieldRoutes } from '../Modules/Field/routes';
import { UserRoutes } from '../Modules/User/routes';
import { FactoryItemsRoutes } from '../Modules/Factory Items/routes';
import { OperationentityProductMappingRoutes } from '../Modules/OpEntityProductMapping/routes';
import { OperationentityCollectionCatagoryMappingRoutes } from '../Modules/OperationentityCollectionCatagoryMapping/routes';
import { MenuRoutes } from '../Modules/MobileMenu/routes';
import { CustomerRoutes } from '../Modules/Customer/routes';
import { CollectioncategoryTypeMappingRoutes } from '../Modules/CollectioncategoryCollectiontypeMapping/routes';
import { CollectionTypeRoutes } from '../Modules/CollectionType/routes';
import { MobilemenuCollectionCatagoryMappingRoutes } from '../Modules/MobileMenuCollectionCategoryMappinng/routes';
import { ProductRoutes } from '../Modules/Product/routes';
import { CollectionCategoryMaster } from '../Modules/CollectionCategoryMaster/routes';
import { FactoryWeightPointRoutes } from '../Modules/FactoryWeightPoint/routes';
import { FactoryItemRequestApprovalRoutes } from '../Modules/FactoryItemRequestApproval/routes';
import { RoleRoutes } from '../Modules/Role/routes';
import { GangRoutes } from '../Modules/Gang/routes';
import { RegularOperationEntityRoutes } from '../Modules/RegularOperationEntity/routes';
import { RegularCollectionPointRoutes } from '../Modules/RegularCollectionPoint/routes';
import { IgnoreSessionRoutes } from "../Modules/IgnoreSession/routes";

import { PackageCreationRoutes } from '../Modules/PackageCreation/routes';
import { SOSRoutes } from '../Modules/SOS/routes';
import { EOSRoutes } from '../Modules/EOS/routes';
import { DeductionRoutes } from '../Modules/Deduction/routes';
import { TaskTemplateRoutes } from '../Modules/TaskTemplate/routes';
import { DailyAttendanceRoutes } from '../Modules/DailyAttendance/routes';
import { TaskCategoryRoutes } from '../Modules/Task/routes';
import { GPSRoutes } from '../Modules/GPS/routes';
import { EmployeeTaskDetailsRoutes } from '../Modules/EmployeeTaskDetails/routes';

import { Layout } from '../Layout';
import { Home } from '../Home';
import { FetchData } from '../FetchData'
import { Counter } from '../Counter';
import { Link } from 'react-router-dom';


import { CardUploadRoutes } from '../Modules/CardUpload/routes';
import { OperationCardRoutes } from '../Modules/OperationCard/routes';
import { CardPrintRoutes } from '../Modules/CardPrint/routes';
import { CardActivateRoutes } from '../Modules/CardActivate/routes';
import { CardSuspendRoutes } from '../Modules/CardSuspend/routes';
import { CardRegenerateRoutes } from '../Modules/CardRegenerate/routes';
import { CommonOperationCardRoutes } from '../Modules/CommonOperationCard/routes';


import { DailyCollectionSummeryReportRoutes } from '../Modules/Reports/DailyCollectionSummery/route';
import { DailyCollectionRoutes } from '../Modules/Reports/DailyCollection/routes';
import { CollectionpointMonthlyDetailReportRoutes } from '../Modules/Reports/CollectionpointMonthlyDetailReport/routes';
import { GoodsTransferDetailsRoutes } from '../Modules/Reports/GoodsTransferDetails/routes';
import { FactoryEmployeeAttendanceReportRoutes } from '../Modules/Reports/FactoryEmployeeAttendanceReport/routes';
import { CustomerLeafCollectionReportRoutes } from '../Modules/Reports/CustomerLeafCollectionReport/routes';
import { EstateComparisonReportRoutes } from '../Modules/Reports/EstateComparisonReport/routes';
import { DivisionSummaryReportRoutes } from '../Modules/Reports/DivisionSummaryReport/routes';
import { DailyCropReconcilliationRoutes } from '../Modules/Reports/DailyCropReconciliation/routes';

import { EmployeeCardUploadRoutes } from '../Modules/EmployeeCardUpload/routes';
import { RsmEmployeeRoutes } from '../Modules/RsmEmployee/routes';

import { RolePermissionRoutes } from '../Modules/RolePermission/routes';
import { CollectionPointRoutes } from '../Modules/CollectionPoint/routes';
import { QRtagRoutes } from '../Modules/QRtagGeneration/routes';
import { CommonGet } from "../../utils/CommonFetch";
import Unauthorized from '../Unauthorize';
import { EmployeeRoutes } from '../Modules/Employee/routes'
import { EstatePackageCreationRoutes } from '../Modules/EstatePackage/routes'
import { QRcodePrintRoutes } from '../Modules/QRcodePrint/routes';
import { TagAmendmentRequestRoutes } from '../Modules/TagAmendment/routes'
import { QRTagGenerationWithFactoryRoutes } from '../Modules/QRTagGenerationWithFactory/routes';
import { QRCodePrintWithFactoryRoutes } from '../Modules/QRcodePrintWithFactory/routes';

// ERP
import { SupplierProfileRoutes } from '../Modules/SupplierProfile/routes'

import { UserPasswordChange } from '../Modules/User/Pages/passwordChange';
import { EmployeeOperationCardRoutes } from '../Modules/EmployeeOperationCard/routes';

import { EmployeeCardPrintRoutes } from '../Modules/EmployeeCardManagement/CardPrint/routes';
import { EmployeeCardActivateRoutes } from '../Modules/EmployeeCardManagement/CardActive/routes';
import { EmployeeCardSuspendRoutes } from '../Modules/EmployeeCardManagement/CardSuspend/routes';
import { EmployeeCardRegenerateRoutes } from '../Modules/EmployeeCardManagement/CardRegenerate/routes';
import { DashBoardRoutes } from '../Modules/Dashboard/routes';

import { WeighingReportRoutes } from '../Modules/Reports/WeighingReport/routes';
import { AdvancedRequestRoutes } from '../Modules/AdvancedRequest/routes';
import { BuyerRoutes } from '../Modules/Buyer/route';

import { GoodsReceiveNoteRoutes } from '../Modules/GoodsReceiveNote/routes';
import { VarianceRoutes } from '../Modules/Reports/VarianceReport/routes';
import { GrossQuantityWiseBagCountRoutes } from '../Modules/Reports/GrossQuentittyWiseBagCount/route';
import { PurchaseAdviceRoutes } from '../Modules/PurchasingAdvice/routes';
import { ExportSupplierRoutes } from '../Modules/ExportSupplier/routes'

import { BulkDeductionRoutes } from '../Modules/BulkDeduction/routes';
import { CommonPackageCreationRoutes } from '../Modules/CommonPackageCreation/route';
import { MonthlyCollectionRoutes } from '../Modules/Reports/MonthlyCollectionReport/routes';
import { ImageRecognitionReportRoutes } from '../Modules/Reports/EmployeeImageRecognitionStatusReport/routes';
import { MasterCardLeafCollectionTagReportRoutes } from '../Modules/Reports/MasterCardLeafTagReport/routes';
import { EmployeeSessionImageReportRoutes } from '../Modules/Reports/EmployeeSessionImageReport/routes';
import { MasterCardLeafCollectionReportRoutes } from '../Modules/Reports/MasterCardLeafCollection/routes';
import { RouteWiseCropDetailsReportRoutes } from '../Modules/Reports/RoutewiseCropDetailReport/routes';
import { DailyLeafCollectionManualReportRoutes } from '../Modules/Reports/DailyLeafCollectionManualReport/routes';
import { LeafSupplierDetailsReportRoutes } from '../Modules/Reports/LeafSupplierDetails/routes';
import { RouteManagerPrintOptionsRoutes } from '../Modules/Reports/RouteMangerPrintOptions/routes';
import { DailyLeafCollectionRouteWiseSummaryReportRoutes } from '../Modules/Reports/DailyLeafCollectionRouteWiseSummary/routes';
import { RouteSummaryReportRoutes } from '../Modules/Reports/RouteSummaryReport/routes';
import { LeafCollectionSummaryReportRoutes } from '../Modules/Reports/LeafCollectionSummaryReport/routes';
import { ManualLeafRoutes } from '../Modules/ManualLeaf/routes';

import { DuplicateTagVerificationRoutes } from '../Modules/DuplicateTagVerification/routes';
import { TagAmendmentRoutes } from '../Modules/TagAmendment/routes';
import { TagAmendmentApprovalRoutes } from "../Modules/TagAmendmentApproval/routes";
import { BlockWeighmentRoutes } from '../Modules/Reports/BlockWeighmentReport/routes';
import { CustomerLeafWiseCollectionReportRoutes } from '../Modules/Reports/CustomerLeafWiseCollectionReport/routes';
import { RouteWiseCollectionTypeReportRoutes } from '../Modules/Reports/RouteWiseCollectionTypeReport/routes';
import { LeafCollectionVarianceReportRoutes } from '../Modules/Reports/LeafCollectionVarianceReport/routes';
import { RouteEmployeeDetailsReportRoutes } from '../Modules/Reports/RouteEmployeeDetailsReport/routes';
import { FactoryRouteWeighReportRoutes } from '../Modules/Reports/FactoryRouteWeighReport/routes';
import { LeafCollectionVarianceRouteWiseReportRoutes } from '../Modules/Reports/LeafCollectionVarianceReportRouteWise/routes';
import { TagMismatchAndReplaceRoutes } from '../Modules/TagException/routes';
import { TotalCropReportRoutes } from '../Modules/Reports/TotalCropReport/routes';
import { LeafAmendmentRoutes } from '../Modules/LeafAmendment/routes';
import { LoftReportRoutes } from '../Modules/Reports/LoftReport/routes';
import { CheckRollSummaryReportRoutes } from '../Modules/Reports/CheckrollWeighSummary/routes';
import { LoftSummaryReportRoutes } from '../Modules/Reports/LoftSummaryReport/routes';
import { lossExcessReportRoutes } from '../Modules/Reports/DailyLossExcessReport/routes';
import { SupplierDairySummaryReportRoutes } from '../Modules/Reports/SupplierDairySummaryReport/routes';
import { DairyCollectionDetailedReportRoutes } from '../Modules/Reports/DairyCollectionDetailedReport/routes';
import { CollectionSummaryReportRoutes } from '../Modules/Reports/CollectionSummaryReport/routes';
import { FactoryItemApprovalRoutes } from '../Modules/FactoryItemApproval/routes';
import { DailyLeafCollectionReportRoutes } from '../Modules/Reports/DailyLeafCollectionReport/routes';
import { RouteLeafCollectionDetailsReportRoutes } from '../Modules/Reports/RouteLeafCollectionDetailsReport/routes';
import { FactoryItemStatusReportRoutes } from '../Modules/Reports/FactoryItemStatusReport/routes';
import { LeafCollectionDetailsReportRoutes } from '../Modules/Reports/LeafCollectionDetailsReport/routes';
import { DivisionSummaryDetailReportRoutes } from '../Modules/Reports/DivisionSummaryDetailReport/routes';
import { OperationEntityConfigurationRoutes } from "../Modules/OperationEntityConfiguration/routes";
import { LeafCollectionVarianceDetailsReportRoutes } from "../Modules/Reports/LeafCollectionVarianceDetailsReport/routes";
import { LeafCollectionOverviewReportRoutes } from '../Modules/Reports/LeafCollectionOverviewReport/routes';
import { RouteDeductionDetailsReportRoutes } from '../Modules/Reports/RouteDeductionDetailsReport/routes';
import { LeafCollectionRouteSummaryReportRoutes } from "../Modules/Reports/LeafCollectionRouteSummaryReport/routes";
import { AdvancedRequestStatusReportRoute } from '../Modules/Reports/AdvancedRequestStatusReport/routes';
import { LoftAmendmentsRoutes } from '../Modules/Reports/LoftAmendmentsReport/routes';
import { EstateGTNFactoriesRoutes } from '../Modules/EstateGTNFactories/routes';
import { EmployeeHarvestingJobEditRoutes } from '../Modules/EmployeeHarvestingJobEdit/routes';
import { TotalCheckRollSummaryReportRoutes } from '../Modules/Reports/TotalCheckRollWeighmentSummaryReport/routes';
import { TaskRoutes } from '../Modules/LabourTask/routes';
import { EmployeeDetailsEstateReportRoutes } from '../Modules/Reports/EmployeeDetailsEstateReport/routes';
import { TotalCheckRollSummaryReportWithNomRoutes } from '../Modules/Reports/TotalCheckRollSummaryWithNom/routes';
import { WeighPointWiseDeductionReportRoutes } from '../Modules/Reports/WeighPointWiseDeductionReport/routes';
import { TaskTemplateBulkRoutes } from '../Modules/TaskTemplateBulk/routes';
import { EmployeeCheckRollDayWiseMonthlyDetailReportRoutes } from '../Modules/Reports/EmployeeCheckRollDayWiseMonthlyDetailReport/routes';
import { DailyCheckRoleSummaryReportRoutes } from '../Modules/Reports/DailyCheckRoleSummaryReport/routes';
import { SessionIgnoreReportRoutes } from '../Modules/Reports/SessionIgnoreReport/routes';
import { EmployeeWiseCheckRollMonthlySummaryReportRoutes } from '../Modules/Reports/EmployeeWiseCheckRollMonthlySummaryReport/routes';
import { DailyTaskDetailReportRoutes } from '../Modules/Reports/DailyTaskDetailReport/routes';
import { TaskDetailReportRoutes } from '../Modules/Reports/TaskDetailReport/routes';
import { EmployeeTaskDetailReportRoutes } from '../Modules/Reports/EmployeeTaskDetailReport/routes';
import { HalfNameMarkReportRoutes } from '../Modules/Reports/HalfNameMarkReport/routes';
import { ExportTagDetailsRoutes } from '../Modules/ExportTagDetails/routes';
import { IntegrationRetryOptionRoutes } from '../Modules/Reports/IntegrationRetryOption/route';
import { FalconReportRoutes } from '../Modules/Reports/FalconReports/routes'
import { FalconTagAmendRoutes } from '../Modules/FalconTagAmend/routes';
import { CustomerAccountReportRoutes } from '../Modules/Reports/CustomerAccountReport/routes';
import { ActiveSupplierCountReportRoutes } from '../Modules/Reports/ActiveSupplierCountReport/routes';
import { RevenueSharedPaymentCalculationRoutes } from '../Modules/RevenueSharedPaymentCalculation/routes';
import { LabourChecklistReportRoutes } from "../Modules/Reports/LabourCheckList/routes";
import { SubordinateCollectionReportRoutes } from "../Modules/Reports/SubordCollectionReport/routes";
import { BLFactoryWeighDetailReportRoutes } from '../Modules/Reports/BLFactoryWeighReport/route';
import { PlukingChecklistReportRoutes } from "../Modules/Reports/PluckingChecklistReport/routes";
import { SundryFactorySummaryReportRoutes } from '../Modules/Reports/SundryFactorySummaryReport/routes';

import { CropVarianceReportRoutes } from "../Modules/Reports/CropVarianceReport/routes";


const drawerWidth = 270;


const styles = theme => ({
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em'
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#48B862',
            outline: '1px solid slategrey'
        }
    },
    root: {
        display: "flex"
    },
    paper: {
        backgroundColor: "#424242",
    },
    appBar: {
        background: '#ffffff',//'linear-gradient(45deg, #ffffff 10%, #43a047 90%)',
        zIndex: theme.zIndex.drawer + 1,
        //backgroundColor: 'linear-gradient(to right, #ffffff 14%, #33cc33 100%)'
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 10,
        color: "#424242"
    },
    menuButtonIconClosed: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(0deg)"
    },
    menuButtonIconOpen: {
        transition: theme.transitions.create(["transform"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        transform: "rotate(180deg)"
    },
    hide: {
        display: "none"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap"

    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        overflowX: "hidden",
        width: theme.spacing.unit * 7 + 1,
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing.unit * 7 + 1
        }
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 6px",

        ...theme.mixins.toolbar
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
    },
    grow: {
        flexGrow: 1
    },
    icontheme: {
        color: "#48B862"
    },
    textcolor: {
        color: "#D3D3D3"

    },
    devidertheme: {
        color: "#48B862",
        height: "20px",
        width: "5px"
    },
    logo: {
        maxWidth: 150
    },
    usertxt: {
        color: "#446600"
    }

});

class CommonHeader extends React.Component {
    state = {
        open: false,
        anchorEl: null,
        anchorE2: null,
        AdministrationOpen: false,
        ProductManagerOpen: false,
        CardManagerOpen: false,
        ReportManagerOpen: false,
        HelpOpen: false,
        mainNavigationMenu: [],
        testopen: false

    };

    async componentDidMount() {
        const response = await CommonGet('/api/MainNavMenu/GetMenuModelsByRole', 'roleID=' + tokenService.getRoleFromToken());
        this.setState({ mainNavigationMenu: response });

    }

    handleDrawerOpen = () => {
        this.setState({ open: !this.state.open });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    handleClick = (event) => {
        this.setState({ anchorE2: event.currentTarget });
    };
    handleMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };
    handleClose = () => {
        this.setState({ anchorEl: null });
    };
    handleMenuq = event => {
        this.setState({ anchorE2: null });
    };
    handleCloseq(id, event) {
        var menuList = this.state.mainNavigationMenu
        menuList.map((item) => {

            item.anchorE2 = null
            item.isOpen = false
        });

        this.setState({ mainNavigationMenu: menuList });
    };



    handleMainMenuDropDown(id, event) {

        var menuList = this.state.mainNavigationMenu
        menuList.map((item) => {
            if (item.mainMenuName == id) {
                item.anchorE2 = event.currentTarget
                item.isOpen = !item.isOpen
            }

        });

        this.setState({ mainNavigationMenu: menuList });
    };

    logoutHandler = () => {
        //window.logout.logout();
        sessionStorage.removeItem('token');
        window.location.replace('/');
    };


    render() {
        const { classes, theme } = this.props;
        const { anchorEl } = this.state;
        const { anchorE2 } = this.state;
        const open = Boolean(anchorEl);
        return (
            <div className={classes.root}>
                <CssBaseline />

                <AppBar
                    position="fixed"
                    className={classes.appBar}
                    fooJon={classNames(classes.appBar, {
                        [classes.appBarShift]: this.state.open
                    })}
                >
                    <hr className={classes.devidertheme} />
                    <Toolbar disableGutters={true}>
                        <IconButton
                            hidden={this.props.isFirstLogin.toString() === 'true'}
                            aria-label="Open drawer"
                            onClick={this.handleDrawerOpen}
                            className={classes.menuButton}
                        >
                            <MenuOpenIcon
                                classes={{
                                    root: this.state.open
                                        ? classes.menuButtonIconOpen
                                        : classes.menuButtonIconClosed
                                }}
                            />
                        </IconButton>
                        <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.grow}
                            noWrap
                        >

                            <a href="/">
                                <img src={logo} alt="" className={classes.logo} />
                            </a>
                        </Typography>
                        <div className={classes.usertxt}>
                            {tokenService.getUserNameFromToken()}

                            <IconButton
                                aria-owns={open ? "menu-appbar" : undefined}
                                aria-haspopup="true"
                                onClick={this.handleMenu}
                                color="inherit"
                                className={classes.icontheme}
                            >
                                <AccountCircle />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "right"
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right"
                                }}
                                open={open}
                                onClose={this.handleClose}
                            >
                                <MenuItem onClick={this.handleClose}>Profile</MenuItem>
                                <MenuItem onClick={this.logoutHandler}>Logout</MenuItem>
                                <MenuItem> <a href="/users/userPasswordChange">Change Password</a></MenuItem>

                            </Menu>
                        </div>
                    </Toolbar>
                </AppBar>
                <Drawer
                    hidden={this.props.isFirstLogin.toString() === 'true'}
                    variant="permanent"
                    className={classNames(classes.drawer, {
                        [classes.drawerOpen]: this.state.open,
                        [classes.drawerClose]: !this.state.open
                    })}
                    classes={{
                        paper: classNames(classes.paper, {
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open
                        }),
                    }
                    }
                    open={this.state.open}
                >
                    <div className={classes.toolbar} />

                    {this.state.mainNavigationMenu.map((menu, index) => (
                        <List key={index} overflow="hidden">
                            <ListItem

                                button
                                onClick={(e) => { this.handleMainMenuDropDown(menu.mainMenuName, e) }}
                                className={classes.textcolor}
                                aria-haspopup="true"
                                aria-controls="fade-menu"
                            >
                                <Tooltip title={menu.mainMenuName} placement="right" arrow>
                                    <ListItemIcon className={classes.icontheme}>
                                        <Icon className={menu.iconTag} style={{ fontSize: 20 }} />
                                    </ListItemIcon>
                                </Tooltip>
                                <ListItemText primary={menu.mainMenuName} className={classes.textcolor} />

                                {menu.isOpen ? <ArrowBackIosIcon style={{ fontSize: 12 }} /> : <ArrowForwardIosIcon style={{ fontSize: 12 }} />}

                            </ListItem>
                            <div className={classes.subMenu}>
                                <Menu
                                    classes={{
                                        paper: classNames(classes.paper),
                                    }}

                                    anchorEl={menu.anchorE2}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "right"
                                    }}
                                    open={menu.isOpen}
                                    onClose={(e) => { this.handleCloseq(menu.mainMenuName, e) }}
                                >

                                    {menu.screenList.map((screen, index) => (
                                        <Link key={index} to={screen.routePath} aria-label="group" className="link" >
                                            <MenuItem onClick={(e) => { this.handleCloseq(menu.mainMenuName, e) }}>
                                                <ListItemIcon className={classes.icontheme} >
                                                    <Icon className={screen.iconTag} style={{ fontSize: 15 }} />
                                                </ListItemIcon>
                                                {screen.screenName}
                                            </MenuItem>

                                        </Link>
                                    ))}
                                </Menu>
                            </div>
                        </List>
                    ))}
                    <Divider />
                </Drawer>
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <Layout>
                        <Switch>
                            {/* <Route exact path='/' component={DashBoardRoutes} /> */}
                            {this.props.isFirstLogin.toString() === 'true' ? <Route exact path='/' component={UserPasswordChange} />
                                : <Route exact path='/' component={DashBoardRoutes} />}
                            {this.props.isFirstLogin.toString() === 'true' ? <Route exact path='/dashboard' component={UserPasswordChange} />
                                : <Route exact path='/dashboard' component={DashBoardRoutes} />}
                            <Route path='/counter' component={Counter} />
                            <Route path='/fetchdata' component={FetchData} />
                            <Route path='/testds' component={Home} />

                            {/* Administration */}
                            <Route path='/Groups' component={GroupRoutes} />
                            <Route path='/Factories' component={FactoryRoutes} />
                            <Route path='/estates' component={EstateRoutes} />
                            <Route path='/routes' component={RouteRoutes} />
                            <Route path='/division' component={DivisionRoutes} />
                            <Route path='/field' component={FieldRoutes} />
                            <Route path='/users' component={UserRoutes} />
                            <Route path='/factoryitems' component={FactoryItemsRoutes} />
                            <Route path='/opproductmapping' component={OperationentityProductMappingRoutes} />
                            <Route path='/opcollectioncatagorymapping' component={OperationentityCollectionCatagoryMappingRoutes} />
                            <Route path='/MobileMenu' component={MenuRoutes} />
                            <Route path='/Customer' component={CustomerRoutes} />
                            <Route path='/collectioncategorytypemapping' component={CollectioncategoryTypeMappingRoutes} />
                            <Route path='/collectiontype' component={CollectionTypeRoutes} />
                            <Route path='/mobilemenucollectioncategorytypemapping' component={MobilemenuCollectionCatagoryMappingRoutes} />
                            <Route path='/products' component={ProductRoutes} />
                            <Route path='/CollectionCategoryMaster' component={CollectionCategoryMaster} />
                            <Route path='/factoryweightpoint' component={FactoryWeightPointRoutes} />
                            <Route path='/role' component={RoleRoutes} />
                            <Route path='/gang' component={GangRoutes} />
                            <Route path='/regularOperationEntity' component={RegularOperationEntityRoutes} />
                            <Route path='/ignoreSession' component={IgnoreSessionRoutes} />
                            <Route path='/operationEntityConfiguration' component={OperationEntityConfigurationRoutes} />
                            <Route path='/EmployeeHarvestingJobEdit' component={EmployeeHarvestingJobEditRoutes} />

                            {/* Product Operations */}
                            <Route path='/packagecreation' component={PackageCreationRoutes} />
                            <Route path='/sos' component={SOSRoutes} />
                            <Route path='/EOS' component={EOSRoutes} />
                            <Route path='/deduction' component={DeductionRoutes} />
                            <Route path='/tasktemplate' component={TaskTemplateRoutes} />
                            <Route path='/dailyAttendance' component={DailyAttendanceRoutes} />
                            <Route path='/taskCategory' component={TaskCategoryRoutes} />
                            <Route path='/GPS' component={GPSRoutes} />
                            <Route path='/QRtagGeneration' component={QRtagRoutes} />
                            <Route path='/QRcodePrint' component={QRcodePrintRoutes} />
                            <Route path='/employeetaskdetails' component={EmployeeTaskDetailsRoutes} />
                            <Route path='/bulkdeduction' component={BulkDeductionRoutes} />
                            <Route path='/manualLeafCollection' component={ManualLeafRoutes} />
                            <Route path='/leafamendRequest' component={TagAmendmentApprovalRoutes} />
                            <Route path='/factoryItemApproval' component={FactoryItemApprovalRoutes} />
                            <Route path='/EstateGTNFactories' component={EstateGTNFactoriesRoutes} />
                            <Route path='/task' component={TaskRoutes} />
                            <Route path='/TaskTemplateBulk' component={TaskTemplateBulkRoutes} />

                            <Route path='/tagAmendment' component={TagAmendmentRoutes} />
                            <Route path='/QRTagGenerationWithFactory' component={QRTagGenerationWithFactoryRoutes} />
                            <Route path='/QRCodePrintWithFactory' component={QRCodePrintWithFactoryRoutes} />
                            <Route path='/revenueSharedPaymentCalculation' component={RevenueSharedPaymentCalculationRoutes} />
                            {/* Card management */}
                            <Route path='/cardupload' component={CardUploadRoutes} />
                            <Route path='/operationcards' component={OperationCardRoutes} />
                            <Route path='/employeecardupload' component={EmployeeCardUploadRoutes} />
                            <Route path='/cardprint' component={CardPrintRoutes} />
                            <Route path='/cardactivate' component={CardActivateRoutes} />
                            <Route path='/cardsuspend' component={CardSuspendRoutes} />
                            <Route path='/cardregenerate' component={CardRegenerateRoutes} />


                            {/* Report */}
                            <Route path='/DailyCollectionReport' component={DailyCollectionRoutes} />
                            <Route path='/DailyCollectionSummeryReport' component={DailyCollectionSummeryReportRoutes} />
                            <Route path='/CollectionpointMonthlyDetailReport' component={CollectionpointMonthlyDetailReportRoutes} />
                            <Route path='/WeighingReport' component={WeighingReportRoutes} />
                            <Route path='/GoodsTransferDetails' component={GoodsTransferDetailsRoutes} />
                            <Route path='/GoodsReceiveNote' component={GoodsReceiveNoteRoutes} />
                            <Route path='/F&FReport' component={VarianceRoutes} />
                            <Route path='/factoryEmployeeAttendanceReport' component={FactoryEmployeeAttendanceReportRoutes} />
                            <Route path='/customerLeafCollectionReport' component={CustomerLeafCollectionReportRoutes} />
                            <Route path='/GrossQuantityWiseBagCount' component={GrossQuantityWiseBagCountRoutes} />
                            <Route path='/estateComparisonReport' component={EstateComparisonReportRoutes} />
                            <Route path='/divisionSummaryReport' component={DivisionSummaryReportRoutes} />
                            <Route path='/dailyCropReconcilliationReport' component={DailyCropReconcilliationRoutes} />
                            <Route path='/employeeCropReport' component={MonthlyCollectionRoutes} />
                            <Route path='/imageStatusReport' component={ImageRecognitionReportRoutes} />
                            <Route path='/masterCardLeafCollectionTagReport' component={MasterCardLeafCollectionTagReportRoutes} />
                            <Route path='/masterCardLeafCollection' component={MasterCardLeafCollectionReportRoutes} />
                            <Route path='/routeWiseCropDetailsReport' component={RouteWiseCropDetailsReportRoutes} />
                            <Route path='/employeeSessionImageReport' component={EmployeeSessionImageReportRoutes} />
                            <Route path='/dailyCollectionMannualLeafReport' component={DailyLeafCollectionManualReportRoutes} />
                            <Route path='/leafSupplierDetails' component={LeafSupplierDetailsReportRoutes} />
                            <Route path='/routeManagerPrintOptionReport' component={RouteManagerPrintOptionsRoutes} />
                            <Route path='/dailyCollectionRouteWiseSummaryReport' component={DailyLeafCollectionRouteWiseSummaryReportRoutes} />
                            <Route path='/routeSummaryReport' component={RouteSummaryReportRoutes} />
                            <Route path='/leafCollectionSummaryReport' component={LeafCollectionSummaryReportRoutes} />
                            <Route path='/blockWeighmentReport' component={BlockWeighmentRoutes} />
                            <Route path='/customerLeafWiseCollectionReport' component={CustomerLeafWiseCollectionReportRoutes} />
                            <Route path='/routeWiseCollectionTypeTotalReport' component={RouteWiseCollectionTypeReportRoutes} />
                            <Route path='/routeEmployeeDetailsReport' component={RouteEmployeeDetailsReportRoutes} />
                            <Route path='/leafCollectionVarianceReport' component={LeafCollectionVarianceReportRoutes} />
                            <Route path='/leafCollectionVarianceRouteWiseReport' component={LeafCollectionVarianceRouteWiseReportRoutes} />
                            <Route path='/factoryRouteWeighReport' component={FactoryRouteWeighReportRoutes} />
                            <Route path='/TotalCropReport' component={TotalCropReportRoutes} />
                            <Route path='/loftReport' component={LoftReportRoutes} />
                            <Route path='/checkRollSummaryReport' component={CheckRollSummaryReportRoutes} />
                            <Route path='/dailyLossExcessReport' component={lossExcessReportRoutes} />

                            <Route path='/LoftDeductionSummaryReport' component={LoftSummaryReportRoutes} />
                            <Route path='/supplierDiarySummaryReport' component={SupplierDairySummaryReportRoutes} />
                            <Route path='/dairyCollectionDetailedReport' component={DairyCollectionDetailedReportRoutes} />
                            <Route path='/collectionSummaryReport' component={CollectionSummaryReportRoutes} />
                            <Route path='/factoryItemStatusReport' component={FactoryItemStatusReportRoutes} />

                            <Route path='/dairyCollectionDetailedReport' component={DairyCollectionDetailedReportRoutes} />
                            <Route path='/dailyLeafCollectionReport' component={DailyLeafCollectionReportRoutes} />
                            <Route path='/RouteLeafCollectionDetailsReport' component={RouteLeafCollectionDetailsReportRoutes} />
                            <Route path='/LeafCollectionDetailsReport' component={LeafCollectionDetailsReportRoutes} />
                            <Route path='/RouteDeductionDetailsReport' component={RouteDeductionDetailsReportRoutes} />

                            <Route path='/leafCollectionVarianceDetailsReport' component={LeafCollectionVarianceDetailsReportRoutes} />
                            <Route path='/divisionSummaryDetailReport' component={DivisionSummaryDetailReportRoutes} />


                            <Route path='/leafCollectionOverviewReport' component={LeafCollectionOverviewReportRoutes} />
                            <Route path='/leafCollectionRouteSummaryReport' component={LeafCollectionRouteSummaryReportRoutes} />

                            <Route path='/advancedRequestStatusReport' component={AdvancedRequestStatusReportRoute} />
                            <Route path='/LoftAmendmentsReport' component={LoftAmendmentsRoutes} />
                            <Route path='/TotalCheckRollWeighmentSummaryReport' component={TotalCheckRollSummaryReportRoutes} />
                            <Route path='/EmployeeDetailsEstateReport' component={EmployeeDetailsEstateReportRoutes} />
                            <Route path='/WeighPointWiseDeductionReport' component={WeighPointWiseDeductionReportRoutes} />

                            <Route path='/TotalCheckRollWeighmentSummaryReportWithNom' component={TotalCheckRollSummaryReportWithNomRoutes} />
                            <Route path='/EmployCheckRollDayWiseMonthlyeeDetailReport' component={EmployeeCheckRollDayWiseMonthlyDetailReportRoutes} />
                            <Route path='/DailyCheckRoleSummaryReport' component={DailyCheckRoleSummaryReportRoutes} />
                            <Route path='/EmployeeWiseCheckRollMonthlySummaryReport' component={EmployeeWiseCheckRollMonthlySummaryReportRoutes} />
                            <Route path='/SessionIgnoreReport' component={SessionIgnoreReportRoutes} />
                            <Route path='/Sundry/FactoryCheckList' component={DailyTaskDetailReportRoutes} />
                            <Route path='/TaskDetailReport' component={TaskDetailReportRoutes} />
                            <Route path='/EmployeeTaskDetailReport' component={EmployeeTaskDetailReportRoutes} />
                            <Route path='/HalfNameMarkReport' component={HalfNameMarkReportRoutes} />
                            <Route path='/IntegrationRetryOption' component={IntegrationRetryOptionRoutes} />
                            <Route path='/customerAccountReport' component={CustomerAccountReportRoutes} />
                            <Route path='/activeSupplierCountReport' component={ActiveSupplierCountReportRoutes} />
                            <Route path='/LabourChecklistReport' component={LabourChecklistReportRoutes} />
                            <Route path='/BLFactoryWeighDetailReport' component={BLFactoryWeighDetailReportRoutes} />
                            <Route path='/SubordinateCollection' component={SubordinateCollectionReportRoutes} />
                            <Route path='/PluckingChecklistReport' component={PlukingChecklistReportRoutes} />
                            <Route path='/Sundry/FactorySummaryReport' component={SundryFactorySummaryReportRoutes} />

                            <Route path='/CropVarianceReport' component={CropVarianceReportRoutes} />




                            {/* Dairy */}
                            <Route path='/collectionpoint' component={CollectionPointRoutes} />


                            <Route path='/rolepermissions' component={RolePermissionRoutes} />
                            <Route path='/unauthorized' component={Unauthorized} />
                            {/* GPS */}
                            <Route path='/productCollectionRoute' component={GPSRoutes} />

                            {/* Estate */}
                            <Route path='/estatePackage' component={EstatePackageCreationRoutes} />
                            <Route path='/employee' component={EmployeeRoutes} />
                            <Route path='/rsmemployee' component={RsmEmployeeRoutes} />
                            <Route path='/employeeOperationCard' component={EmployeeOperationCardRoutes} />

                            {/* Employee managementy */}
                            <Route path='/employeecardprint' component={EmployeeCardPrintRoutes} />
                            <Route path='/employeecardactivate' component={EmployeeCardActivateRoutes} />
                            <Route path='/employeecardsuspend' component={EmployeeCardSuspendRoutes} />
                            <Route path='/employeecardregenerate' component={EmployeeCardRegenerateRoutes} />


                            {/* erp */}
                            <Route path='/supplierProfile' component={SupplierProfileRoutes} />
                            <Route path='/advancedRequest' component={AdvancedRequestRoutes} />

                            {/*ExportCollectionPointRoutes*/}
                            <Route path='/regularCollectionPoint' component={RegularCollectionPointRoutes} />
                            <Route path='/buyer' component={BuyerRoutes} />
                            <Route path='/PurchaseAdvice' component={PurchaseAdviceRoutes} />
                            <Route path='/TagDetails' component={ExportTagDetailsRoutes} />

                            {/* Supplier */}
                            <Route path='/exportSupplier' component={ExportSupplierRoutes} />

                            {/* Common Package Creation */}
                            <Route path='/commonPackage' component={CommonPackageCreationRoutes} />
                            {/*Common OperationCard*/}
                            <Route path='/commonoperationcard' component={CommonOperationCardRoutes} />

                            {/*DuplicateTagVerification*/}
                            <Route path='/duplicateTagVerification' component={DuplicateTagVerificationRoutes} />
                            <Route path='/leafAmendment' component={LeafAmendmentRoutes} />

                            {/*Tag Mismatch And Replace*/}
                            <Route path='/tagmismatchandreplace' component={TagMismatchAndReplaceRoutes} />
                            <Route path='/falconProducCollection' component={FalconReportRoutes} />
                            <Route path='/falconTagAmend' component={FalconTagAmendRoutes} />

                        </Switch>
                    </Layout>
                </main>
            </div>
        );
    }
}

CommonHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired
};


export default withStyles(styles, { withTheme: true })(CommonHeader);